import type { FetchKey } from '@app/src/api/fetchHooks'
import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import { AssessmentType } from '@app/src/types/resourceExplorer'
import React from 'react'
import type { IntlFormatters } from 'react-intl'
import { AssessmentFacetFilter } from './AssessmentFacetFilter'

interface Props {
  template: AssessmentTemplate
  prefix?: string
  fetchKey: FetchKey
  facetEndpoint: string
  formatMessage: IntlFormatters['formatMessage']
}

const AssessmentLevelFilters: React.FC<Props> = ({ template, prefix, fetchKey, facetEndpoint, formatMessage }) => {
  const levelsCount = template.levels ?? 5
  const assessmentType = template.assessmentType
  const levelNamesType = template.levelNamesType

  const totalLevelName = prefix ? `${prefix}.totalLevel` : 'totalLevel'

  const shouldShowSections =
    assessmentType === AssessmentType.Flexible || assessmentType === AssessmentType.BaselineAssessment

  const sectionFilters =
    shouldShowSections && template.sections
      ? template.sections.map(section => {
          const name = prefix
            ? `${prefix}.section${section.assessmentSectionNumber}Level`
            : `section${section.assessmentSectionNumber}Level`
          return {
            key: name,
            name,
            label: section.name,
            shouldFormatLabel: false,
          }
        })
      : []

  const filters = [
    {
      key: 'totalLevel',
      name: totalLevelName,
      label: 'assessment.filter.result',
      shouldFormatLabel: true,
    },
    ...sectionFilters,
  ]

  return (
    <>
      {filters.map(({ key, name, label, shouldFormatLabel }) => (
        <AssessmentFacetFilter
          key={key}
          name={name}
          label={label}
          levelsCount={levelsCount}
          assessmentType={assessmentType}
          levelNamesType={levelNamesType}
          fetchKey={fetchKey}
          facetEndpoint={facetEndpoint}
          formatMessage={formatMessage}
          {...(shouldFormatLabel === false && { shouldFormatLabel: false })}
        />
      ))}
    </>
  )
}

export default AssessmentLevelFilters
